import Accordion from '@ancon/wildcat-ui/web/orderweb/Accordion'
import '@ancon/wildcat-ui/web/orderweb/Accordion/Accordion.css'
import '@ancon/wildcat-ui/web/orderweb/InteractiveDiv/InteractiveDiv.css'

export default Accordion
